import type { IconData } from '@stacksjs/iconify-core'

export const direction: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12 19.5a1 1 0 0 1-.707-.293l-3-3a1 1 0 0 1 1.414-1.414L12 17.086l2.293-2.293a1 1 0 0 1 1.414 1.414l-3 3A1 1 0 0 1 12 19.5m3-9a1 1 0 0 1-.707-.293L12 7.914l-2.293 2.293a1 1 0 0 1-1.414-1.414l3-3a1 1 0 0 1 1.414 0l3 3A1 1 0 0 1 15 10.5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default direction
